import { BaseMatcher, Matcher } from './base.matcher';

export function notNull<T>(message: () => string = () => 'value must not be null'): Matcher<T> {
  return new BaseMatcher<T>((input) => {
    if (input === null) {
      return false;
    }
    return true;
  }, message);
}
